import React, { useState } from 'react';
import './mobileNumber.scss';
import { IonGrid, IonImg, IonLabel, IonRow } from '@ionic/react';
import { IONICWrapper } from '../common';
import { CountryCodesForUser, defaultCountryCode } from '../constants';

const MobileNumber = (props: any) => {
  const CountryCodes = IONICWrapper?.details?.keys?.configuration?.CountryCodes || CountryCodesForUser;
  const defaultMobileNumber = defaultCountryCode;
  const countryCodesValues: string[] = Object.values(CountryCodes);
  const [showDropDown,setShowDropDown] = useState(false);
  const [countryCode,setCountryCode] = useState<string>(defaultMobileNumber);
  const [payloadCountryCode,setPayloadCountryCode] = useState<string>("");
  const resrictValues = (e: any) => {
    const regex = new RegExp("^[0-9-]+$");
    const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }
  const onChange = (e: any) => {
    if (props.handleValueChange) {
      props.handleValueChange(e)
    }
  }

  const onBlur = (event: any) => {
    const { name, value}: any = event.target;
    if (props.validateFeilds) {
      props.validateFeilds(event)
    }
    if (props.mobileValidation && props.mobileNumber.length >= 12 && name === 'mobileNumber' && !!value) {
      props.mobileValidation(value);
    } 
  }
  return (
    (props.showAsLabel) ?
      <>
        <IonLabel className="mobile-number">{props.countryCodefromMember? props.countryCodefromMember:props.isMobile ? props.countryCode : countryCode}{" "}</IonLabel>
        <IonLabel className="mobile-number">{props.mobileNumber}</IonLabel>
      </> :
      <>
        <div className="warper-div">
          {props.label && 
          <IonLabel className="mobile-number">{props.label}</IonLabel>
          }
          <div className={`number-input-field${props.mobileValidateError ? " error": ""}${props.addUser?" highlightField":""}`}>
            <input className="mobile-number country-field" value={props.countryCodefromMember? props.countryCodefromMember:props.isMobile ? props.countryCode : countryCode} readOnly /> 
            {!props.nonEditableField && 
            <IonImg
              src="assets/icon/down arrow@2x.png"
              onClick={() => {
                setShowDropDown(!showDropDown);
                props.isMobile && props.setShowDropDown && props.setShowDropDown(!props.showDropDown);
              }}
            />}
            <input
              type="text"
              className="mobile-number number-field"
              name={props.name}
              placeholder={props.placeholder}
              onChange={onChange}
              value={props.mobileNumber || ""}
              maxLength={12}
              data-testid="mobileNumber"
              onBlur={(event) => onBlur && onBlur(event)}
              readOnly={props.mobileReadOnly}
              onKeyPress={resrictValues}
              onFocus={(event) => props.onFocus && props.onFocus(event,props.isMobile ? props.countryCode : countryCode,payloadCountryCode)}
            />
          </div>
        </div>
        {(showDropDown && !props.isMobile && !props.nonEditableField) ?
              <IonGrid className="dropdown-option-grid" >   
              {countryCodesValues && 
              <>
              {CountryCodes.map((code: any) => {
                return <IonRow
                  onClick={() => {
                  setCountryCode(Object.values(code).toString());
                  setPayloadCountryCode(Object.keys(code).toString());
                  setShowDropDown(false);
                  props.mobileNumber.length >=12 && (props.mobileValidation && props.mobileValidation(props.mobileNumber,Object.values(code).toString(),Object.keys(code).toString()))
                }}
                > {Object.values(code).toString()} </IonRow>
              })}                
              </>
              }
            </IonGrid> : null
            }
      </>
  )
}

export default React.memo(MobileNumber); 